import {
  Container,
  Dropdown,
  Form,
  Input,
  LoadingMessage,
  NoResults,
  ResultCollection,
  ResultItem,
  ResultName,
  ResultReference,
  SubmitButton,
} from "./style";
import { compose, withStateHandlers } from "recompose";

import React from "react";
import _debounce from "lodash/debounce";
import { connect } from "react-redux";
import { graphql } from "react-apollo";
import { productSearchByReferenceQuery } from "../../graphql/queries";
import searchProductsByReferenceOffline from "../../search-index";
import withRouter from "react-router-dom/withRouter";

export default compose(
  connect(({ status }) => ({ online: status.online })),
  withRouter,
  withStateHandlers(
    { text: "", search: "", isOpen: false },
    {
      setText: () => (text) => ({ text, isOpen: !!text }),
      setSearch: () => (search) => ({ search }),
      close: () => () => ({ isOpen: false }),
      reset: () => () => ({ text: "", search: "", isOpen: false }),
    },
  ),
  graphql(productSearchByReferenceQuery, {
    skip: ({ online, search }) => !online || !search,
    options: ({ search }) => ({
      variables: { search, limit: 10 },
    }),
    props: ({ data: { loading, results } }) => ({
      onlineResults: results,
      onlineLoading: loading,
    }),
  }),
)(
  class Search extends React.Component {
    state = { offlineResults: null };

    // Créé une seule fois par instance (constructor), pour que le debounce reste stable.
    debouncedSetSearch = _debounce(this.props.setSearch, 300);

    containerRef = null;
    setContainerRef = (node) => {
      this.containerRef = node;
    };

    handleOutsideClick = (evt) => {
      if (this.containerRef && !this.containerRef.contains(evt.target)) {
        this.props.close();
      }
    };

    componentDidMount() {
      // mousedown se déclenche aussi bien pour un clic souris que pour un tap tactile.
      document.addEventListener("mousedown", this.handleOutsideClick);
    }

    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleOutsideClick);
    }

    componentDidUpdate(prevProps) {
      const { search, online } = this.props;
      if (search === prevProps.search && online === prevProps.online) return;
      if (!search) return this.setState({ offlineResults: null });
      if (online) return;
      searchProductsByReferenceOffline(search, 10).then((offlineResults) =>
        this.setState({ offlineResults }),
      );
    }

    onChangeText = (evt) => {
      const { value } = evt.target;
      this.props.setText(value);
      this.debouncedSetSearch(value);
    };

    onKeyDown = (evt) => {
      if (evt.key === "Escape") this.props.close();
    };

    goToResult = (result) => {
      this.props.history.push(
        `/collections/${result.productKind}/${result.collectionSlug}`,
        { activeReference: result.reference },
      );
      this.props.reset();
    };

    onSubmit = (evt) => {
      evt.preventDefault();
      // Valider la recherche (bouton ou Entrée) bascule sur le premier résultat de la
      // liste (déjà trié, le plus pertinent en premier), même sans correspondance exacte
      // ni clic sur une ligne du dropdown.
      const [firstResult] = this.getResults();
      if (firstResult) this.goToResult(firstResult);
    };

    getResults = () => {
      const { online, onlineResults } = this.props;
      return (online ? onlineResults : this.state.offlineResults) || [];
    };

    render() {
      const { text, isOpen, online, onlineLoading } = this.props;
      const results = this.getResults();
      const loading = online && onlineLoading;

      return (
        <Container innerRef={this.setContainerRef}>
          <Form onSubmit={this.onSubmit}>
            <Input
              placeholder="Recherche par référence…"
              value={text}
              onChange={this.onChangeText}
              onKeyDown={this.onKeyDown}
            />
            <SubmitButton disabled={!results.length}>
              Voir le produit
            </SubmitButton>
          </Form>
          {isOpen && !!text && (
            <Dropdown>
              {loading ? (
                <LoadingMessage>Recherche en cours&hellip;</LoadingMessage>
              ) : results.length ? (
                results.map((result) => (
                  <ResultItem
                    key={result.variantId}
                    onClick={() => this.goToResult(result)}
                  >
                    <ResultName>{result.productName}</ResultName>
                    <ResultReference>#{result.reference}</ResultReference>
                    <ResultCollection>
                      Collection {result.collectionName}
                    </ResultCollection>
                  </ResultItem>
                ))
              ) : (
                <NoResults>
                  Aucun produit ne correspond à cette référence.
                </NoResults>
              )}
            </Dropdown>
          )}
        </Container>
      );
    }
  },
);
